import type { EcsConfigStateSnapshotReporter } from 'owa-analytics-types';
import {
    getLocalEcsConfigStateSdkSnapshotRevision,
    getLocalEcsConfigStateSdkSnapshots,
    subscribeEcsConfigStateSdkSnapshots,
} from 'owa-analytics-utils/lib/ecsConfigStateSdkSnapshots';
import { releaseProxy } from 'comlink';
import { trace } from 'owa-trace';

let unsubscribe: (() => void) | undefined;
let reporter: EcsConfigStateSnapshotReporter | undefined;

export function reportEcsConfigStateSdkSnapshots(report: EcsConfigStateSnapshotReporter): void {
    unsubscribe?.();
    if (reporter && releaseProxy in reporter && typeof reporter[releaseProxy] === 'function') {
        try {
            reporter[releaseProxy]();
        } catch {
            trace.warn('Config-state SDK snapshot proxy could not be released.', 'analytics');
        }
    }
    reporter = report;
    const publish = async () => {
        try {
            await report(
                getLocalEcsConfigStateSdkSnapshots(),
                getLocalEcsConfigStateSdkSnapshotRevision()
            );
        } catch {
            trace.warn('Config-state SDK snapshot notification failed.', 'analytics');
        }
    };
    unsubscribe = subscribeEcsConfigStateSdkSnapshots(() => {
        void publish();
    }, true);
    void publish();
}
